<script setup lang="ts">
import searchVehicleResponse from "@/types/responses/getVehicle";
import temperatureInformationSpotResponse from "@/types/responses/temperatureInformationSpot";
import i18n from '@/lang/i18n';

const props = defineProps<{
  vehicles: searchVehicleResponse[],
  spots: temperatureInformationSpotResponse[] | null,
  isLoading: boolean,
}>();

const headerListRow1 = [
  i18n.global.t('pages.temperatureSensors.informationNumerical.list.header.department'),
  i18n.global.t('pages.temperatureSensors.informationNumerical.list.header.vehicle'),
  i18n.global.t('pages.temperatureSensors.informationNumerical.list.header.temperature'),
  i18n.global.t('pages.temperatureSensors.informationNumerical.list.header.dateTime'),
  i18n.global.t('pages.temperatureSensors.informationNumerical.list.header.sopt'),
];

const headerListRow2 = [
  i18n.global.t('pages.temperatureSensors.informationNumerical.list.header.ch1'),
  i18n.global.t('pages.temperatureSensors.informationNumerical.list.header.ch2'),
  i18n.global.t('pages.temperatureSensors.informationNumerical.list.header.ch3'),
  i18n.global.t('pages.temperatureSensors.informationNumerical.list.header.ch4'),
];
const NUMBER_PLATE_INDEX = 1;
const TEMPERATURE_SENSOR_INDEX = 2;
const SPOT_INDEX = 4;

function headerListRow1Rowspan(index: number) {
  if (index == TEMPERATURE_SENSOR_INDEX) return 1;
  return 2;
}

function headerListRow1Colspan(index: number) {
  if (index == NUMBER_PLATE_INDEX || index == SPOT_INDEX) return 2;
  if (index == TEMPERATURE_SENSOR_INDEX) return 4;
  return 1;
}

</script>
<template>
  <div class="list mb-2">
    <template v-if="props.isLoading">
      <div class="list-loading">
        <label>{{ i18n.global.t('pages.common.list.reading') }}</label>
      </div>
    </template>
    <v-table
      :fixed-header="true"
      density="comfortable"
    >
      <thead cols="12">
        <tr>
          <th v-for="(listItem, index) in headerListRow1"
            :key="index"
            :rowspan="headerListRow1Rowspan(index)"
            :colspan="headerListRow1Colspan(index)"
            class="text-center"
            style="background-color: #f8f9fa;"
          >
            <div>{{ listItem }}</div>
          </th>
        </tr>
        <tr>
          <th v-for="(listItem, index) in headerListRow2"
            :key="index"
            class="text-center"
            style="background-color: #f8f9fa;"
          >
            <div>{{ listItem }}</div>
          </th>
        </tr>
      </thead>
      <tbody>
        <template v-if="props.vehicles?.length">
          <tr v-for="vehicle in props.vehicles" :key="vehicle.id">
            <td class="column-space" colspan="1">{{ vehicle.department?.name}}</td>
            <td class="column-space" colspan="2">{{ vehicle.number_plate }}</td>
            <td class="column-space" colspan="1">{{ vehicle.ch1 }}</td>
            <td class="column-space" colspan="1">{{ vehicle.ch2 }}</td>
            <td class="column-space" colspan="1">{{ vehicle.ch3 }}</td>
            <td class="column-space" colspan="1">{{ vehicle.ch4 }}</td>
            <td class="column-space" colspan="1">{{ vehicle.datetime }}</td>
            <td class="column-space" colspan="2">{{ vehicle.spot_name }}</td>
          </tr>
        </template>
        <template v-else-if="!props.vehicles?.length && !isLoading">
          <tr>
            <td colspan="9" class="pt-2" style="height: 300px; vertical-align: top;">
              {{ i18n.global.t('pages.common.list.noData') }}
            </td>
          </tr>
        </template>
      </tbody>
    </v-table>
  </div>
</template>
<style scoped>
table, td {
  border: 1px solid rgb(var(--v-border-color), var(--v-border-opacity));
}

table th {
  border-left: 1px solid rgb(var(--v-border-color), var(--v-border-opacity));
  border-right: 1px solid rgb(var(--v-border-color), var(--v-border-opacity));
}
</style>
